import React from 'react';
import './Contact.css';
import { FaEnvelope, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <h2>Contáctanos</h2>
      <p>
        <FaEnvelope /> Email: <a href="mailto:msgroupsac16@gmail.com">msgroupsac16@gmail.com</a>
      </p>
      <p>
        <FaWhatsapp /> WhatsApp: <a href="https://walink.co/04086c">991135834</a>
      </p>

      <form className="contact-form">
        <label htmlFor="name">Nombre</label>
        <input type="text" id="name" name="name" placeholder="Ingresa tu nombre completo" required />

        <label htmlFor="phone">Teléfono</label>
        <input type="tel" id="phone" name="phone" placeholder="Ingresa tu número de teléfono" required />

        <label htmlFor="email">Correo Electrónico</label>
        <input type="email" id="email" name="email" placeholder="Ingresa tu correo electrónico" required />

        <label htmlFor="message">Mensaje</label>
        <textarea id="message" name="message" placeholder="Escribe tu mensaje" required></textarea>

        <button type="submit">Enviar Mensaje</button>
      </form>

      {/* Sección del mapa */}
      <div className="map-container">
        <h3>Nuestra Ubicación</h3>
        <iframe
          title="Ubicación en Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15631.271816430835!2d-79.84270588246234!3d-6.773897022392761!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x904ced9ad7b789b9%3A0x72b3f8d83ac4b504!2sSan%20Jos%C3%A9%20509%2C%20Chiclayo%2014001!5e0!3m2!1ses-419!2spe!4v1700000000000!5m2!1ses-419!2spe"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;